export default {
    ai: 'KI-Assistent',
    export: 'Exportieren',
    blue: 'Blau',
    yellow: 'Gelb',
    pink: 'Rosa',
    orange: 'Orange',
    all: 'Alle',
    generateApaCopy: 'APA-Zitat generieren',
    apaCopied: 'Zitat in die Zwischenablage kopiert!',
    imReading: `Ich lese gerade`,
    in: 'in',
    by: 'Von',
    article: 'Artikel',
    prevArticle: 'Vorheriger Artikel',
    nextArticle: 'Nächster Artikel',
    imHere: `Ja, ich bin hier`,
    sessionExpiredAlert: 'Ihre Lesesitzung geht bald zu Ende.',
    sessionExpiredAreYouThere: 'Bist du da?',
    sessionExpired: 'Ihre Lesesitzung ist aufgrund von Inaktivität abgelaufen.',
    returnToLibrary: 'Zurück zur Bibliothek',
    sessionValidExpired: 'Sitzung abgelaufen',
    sessionValidExpiredPleaseLoginAgain: 'Bitte loggen Sie sich erneut ein',
    tableOfContents: 'Inhaltsverzeichnis',
    tableOfContentsNotAvailable: 'Kein Inhaltsverzeichnis verfügbar.',
    pages: 'Seiten',
    page: 'Seite',
    thumbnails: 'Thumbnails',
    settings: 'Einstellungen',
    bookmarks: 'Lesezeichen',
    highlights: 'Markierungen',
    highlight: 'Markieren',
    notes: 'Notizen',
    note: 'Notiz',
    notebook: 'Notizen',
    search: 'Suchen',
    theme: 'Design',
    pageLayout: 'Seitenlayout',
    typography: 'Typografie',
    fontDefault: 'Standard',
    lineSpacing: 'Zeilenabstand',
    lineSpacingCompact: 'Kompakt',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Weit',
    margins: 'Ränder',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maximum',
    readingModes: 'Lesemodi',
    zoomTitle: 'Textgröße',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    continuous: 'Fortlaufend',
    onePage: 'Horizontales',
    onePageScroll: 'Vertikales',
    twoPages: 'Doppelte',
    twoPagesScroll: 'Scrollen auf zwei Seiten',
    citation: {
        buttons: {
            Iso690: 'Generate ISO690 citation',
            APA: 'APA-Zitat generieren',
            Vancouver: 'Generate Vancouver citation',
            IEEE: 'IEEE-Zitat generieren',
            MLA: 'Generate MLA citation',
            ABNT: 'ABNT-Zitat generieren',
        },
        menu: {
            title: 'Zitat generieren',
            Iso690: 'ISO 690',
            APA: 'APA',
            Vancouver: 'Vancouver',
            IEEE: 'IEEE',
            MLA: 'MLA',
            ABNT: 'ABNT',
        },
        messages: {
            copied: 'Zitat in die Zwischenablage kopiert!',
            availableIn: 'Verfügbar in',
            online: 'Internet',
            generated: 'zitiert',
            websiteName: 'publica.la',
            and: 'und',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Konzept erklären',
            expand: 'Informationen erweitern',
            summarize: 'Idee zusammenfassen',
        },
        menu: {
            title: 'AI Assistant (Beta)',
        },
        messages: {
            copied: '¡Antwort in die Zwischenablage kopiert!',
            addedToResponse: '«Antwort von publica.la Reader kopiert»',
        },
        thanksFeedback: 'Vielen Dank für Ihr Feedback!',
        errorFeedback: 'Senden des Feedbacks fehlgeschlagen. Können Sie es erneut versuchen?',
    },
    onlyCopy: 'Klartext kopieren',
    translate: 'Übersetzen',
    //chequear esto
    copy: 'kopieren',
    changeColor: 'Farbe ändern',
    socialShare: 'Teilen',
    zoom: {
        auto: 'Automatisch',
        'page-fit': 'Passende Seite',
        'page-width': 'Seitenbreite',
    },
    filter: 'Filtern',
    noFilterHighlights: 'Wählen Sie einen Filter aus, um Ihre Highlights zu sehen',
    noFilterHighlightsColor: 'In dieser Farbe ist nichts hervorgehoben',
    noHighlights: 'Sie haben noch keine Markierungen gesetzt',
    noFilterNotes: 'Wählen Sie eine Farbe, um die Notizen zu sehen',
    noFilterNotesColor: 'Es gibt keine Notizen dieser Farbe',
    noNotes: 'Sie haben noch keine Notizen geschrieben',
    noFilterHighlightsAndNotes: 'Wählen Sie eine Farbe, um Ihre Markierungen und Notizen zu sehen',
    noFilterHighlightsAndNotesColor: 'Es gibt keine Notizen oder Markierungen dieser Farbe',
    noHighlightsAndNotes: 'Sie haben noch keine Markierungen oder Notizen erstellt',
    plainCopied: 'Text in die Zwischenablage kopiert.',
    onboarding: {
        next: 'Weiter',
        finish: 'Fertig',
        skip: 'Tutorial überspringen',
        previous: 'Vorherige',
        reader: {
            welcome: {
                title: 'Willkommen in deinem Lesebereich',
                paragraph:
                    'Entdecke, wie du das Beste aus deinen Büchern herausholst mit den verfügbaren Werkzeugen im Reader.',
                extraParagraph: 'Genieße deinen neuen Lesebereich!',
            },
            highlights: {
                title: 'Verbessere dein Leseerlebnis',
                paragraph:
                    'Wähle Text aus, markiere, erstelle Notizen, generiere Zitate, übersetze und höre den Inhalt. Hebe dein Leseerlebnis auf das nächste Level in allen Formaten.',
            },
            resumes: {
                title: 'Verwalte deinen Inhalt',
                paragraph:
                    'Steigere deine Produktivität. Verwalte deine Notizen, Markierungen, Zitate und Zusammenfassungen nach Belieben. Teile deine Ideen schnell und einfach.',
            },
            appPromote: {
                title: 'Lese oder höre überall',
                paragraph:
                    'Greife auf deinen Inhalt zu, wann und wie du willst, ohne Internetverbindung, auf deinem bevorzugten Gerät.',
                extraParagraph: 'Lade unsere App herunter!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Willkommen',
                subTitle: 'Wie benutzt man den Audio Player?',
                paragraph: 'Erfahren Sie, wie Sie das Beste aus Ihrem Hörerlebnis herausholen können.',
            },
            reproduction: {
                title: 'Wiedergabesteuerung',
                paragraph: 'Gehen Sie vor und zurück oder unterbrechen Sie die Hörbuchwiedergabe.',
            },
            narratorSpeed: {
                title: 'Geschwindigkeit der Erzählung',
                paragraph: 'Sie können mit dem Hörbuch, das Sie gerade hören, die Geschwindigkeit anpassen.',
            },
            chapters: {
                title: 'Kapitel',
                paragraph: 'Wechseln Sie schnell zwischen den Kapiteln.',
            },
        },
    },
    author: 'Autor',
    publisher: 'Verlag',
    narrator: 'Sprecher',
    narratedBy: 'Gesprochen von',
    aboutThisPublication: 'Über diese Veröffentlichung',
    listening: {
        label: 'Abspielen',
        voice: 'Stimme',
    },
    searchResultEmpty: 'Keine Ergebnisse gefunden',
    searchLengthError: 'Die Suche muss zwischen 4 und 128 Zeichen lang sein',
    keepTyping: 'Weiterschreiben…',
    loading: 'Wird geladen...',
    searchLoading: 'Suchen...',
    searchTitle: 'Suche',
    lastSearch: 'Vorschläge',
    searchExplanation: 'Finden Sie Wörter schnell und intelligent in allen Publikationen',
    networkIsOffline: 'Keine Internetverbindung verfügbar. Einige Funktionen sind nicht verfügbar.',
    about: 'Über',
    chapters: 'Kapitel',
    duration: 'Dauer',
    narratorSpeed: 'Tempo',
    slowNarration: 'Langsames Tempo',
    normalNarration: 'Normales Tempo',
    fastNarration: 'Schnelles Tempo',
    shareIssue: 'Publikation teilen',
    shareArticle: 'Artikel teilen',
    copyUrl: 'URL kopieren',
    shareCurrentPage: 'Aktuellen Seite teilen',
    shareCurrentPosition: 'Aktuelle Position teilen',
    copyUrlToClipboard: 'URL in die Zwischenablage kopiert',
    tooltips: {
        zoomOut: 'Herauszoomen',
        zoomIn: 'Hineinzoomen',
        config: 'Konfiguration',
        tableOfContents: 'Inhaltsverzeichnis',
        search: 'Suchen',
        highlights: 'Markierungen',
        notebook: 'Notizen',
        listen: 'Abspielen',
        bookmarks: 'Lesezeichen',
        openThumbnails: 'Vorschaubilder',
        closeThumbnails: 'Miniaturansichten beenden',
        download: 'Offline-Zugriff',
        share: 'Teilen',
        prev: 'Vorheriger',
        next: 'Nächster',
        close: 'Schließen',
        back: 'Zurück',
        themeTitle: 'Aussehen',
        themeLight: 'Hell',
        themeDark: 'Dunkel',
        themeCream: 'Creme',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'Hoher Kontrast',
        themeHighContrastDark: 'Hoher Kontrast dunkel',
        clear: 'Löschen',
        citation: 'Zitat',
        dictionary: 'Wörterbuch',
        aiIntegrations: 'AI Assistant (Beta)',
        aiAction:
            'Dieses Werkzeug verwendet KI, daher können ungenaue Informationen enthalten sein. Weitere Verbesserungen folgen in Kürze! Was denken Sie? Verwenden Sie die untenstehenden Symbole, um Ihre Meinung zu äußern.',
        translate: 'Übersetzen',
        about: 'Über',
        rewind: 'Zurückspulen',
        forward: 'Vorspulen',
        createNote: 'Notiz erstellen',
        createHighlight: 'Hervorheben',
        deleteHighlight: 'Markierung löschen',
        help: 'Hilfe',
        lists: 'Listen',
        copy: 'Kopieren',
        goodResponse: 'Gute Antwort',
        badResponse: 'Schlechte Antwort',
        ai: 'KI-Assistent',
        moreActions: 'Weitere Aktionen',
        moreOptions: 'Weitere Optionen',
        play: 'Abspielen',
        pause: 'Pause',
        seekPosition: 'Spurposition',
        zoomReset: 'Zoom zurücksetzen',
        smartZoom: 'Smart Zoom',
        themeSystem: 'Systemdesign',
        searchInBook: 'Im Buch suchen',
        pageSlider: 'Seitennavigation',
    },
    save: 'Speichern',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    confirmDelete: {
        title: 'Anmerkung löschen',
        message:
            'Sind Sie sicher, dass Sie diese Anmerkung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    confirmResetSettings: {
        title: 'Einstellungen zurücksetzen',
        message: 'Alle visuellen Einstellungen werden auf ihre Standardwerte zurückgesetzt.',
    },
    resetSettings: 'Einstellungen zurücksetzen',
    writeNote: 'Notiz schreiben',
    speakNow: 'Jetzt sprechen',
    listeningSpeech: 'Zuhören',
    share: {
        copyShare: 'Kopieren und teilen',
        qrCodeTitle: 'QR-Code',
        scanQr: 'Scannen Sie den QR-Code mit Ihrer WeChat-App',
        copyLink: 'Kopieren Sie die URL der Veröffentlichung',
        copy: 'Kopieren',
        copied: 'Kopiert',
        openWechat: 'WeChat-App öffnen',
        openingWechat: 'Öffnen der WeChat-App...',
        sendCopiedUrl: 'Kopierte URL an einen Kontakt senden',
    },
    playing: 'Wiedergabe',
    buyNow: 'Jetzt kaufen',
    buyNowText: 'Holen Sie sich die Vollversion',
    preview: 'Hör-/Leseprobe',
    changeLayoutNotAllowed: 'Der Inhalt erlaubt es nicht, das Seitenlayout zu ändern',
    nativeTtsLang: {
        'en-US': 'Englisch (Vereinigte Staaten)',
        'en-GB': 'Englisch (Großbritannien)',
        'en-scotland': 'Englisch (Schottland)',
        'en-AU': 'Englisch (Australien)',
        'en-IE': 'Englisch (Irland)',
        'en-IN': 'Englisch (Indien)',
        'en-ZA': 'Englisch (Südafrika)',
        en: 'Englisch',
        'es-AR': 'Spanisch (Argentinien)',
        'es-ES': 'Spanisch (Spanien)',
        'es-MX': 'Spanisch (Mexiko)',
        'es-US': 'Spanisch (Vereinigte Staaten)',
        es: 'Spanisch',
        'it-IT': 'Italienisch (Italien)',
        it: 'Italienisch',
        'pt-PT': 'Portugiesisch (Brasilien)',
        'pt-BR': 'Portugiesisch (Portugal)',
        pt: 'Portugiesisch',
        'fr-CA': 'Französisch (Kanada)',
        'fr-FR': 'Französisch (Frankreich)',
        fr: 'Französisch',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: 'Im App Store herunterladen',
        downloadPlayStore: 'Bei Google Play herunterladen',
        title_read: 'Nehmen Sie Ihre Titel überall hin mit',
        title_audio: 'Nehmen Sie Ihre Hörbücher überall hin mit.',
        text: 'Greife auf deine Inhalte zu, wann und wie du möchtest, ohne Internetverbindung, auf dem Gerät deiner Wahl. Lade unsere App herunter!',
        title_first_part: 'Mit',
        title_second_part: 'nimm deine Lektüre überallhin mit',
    },
    dictionary: 'Wörterbuch',
    selectionTooLongLine1: 'Die Auswahl enthält zu viele Wörter.',
    selectionTooLongLine2: 'Versuchen Sie, bis zu 5 Wörter auszuwählen.',
    dictionaryValidation: {
        message: 'Sie haben {count} Wörter ausgewählt.\nBitte versuchen Sie, bis zu {max} Wörter auszuwählen.',
    },
    translateValidation: {
        message: 'Sie haben {count} Zeichen ausgewählt.\nBitte versuchen Sie, bis zu {max} Zeichen auszuwählen.',
    },
    ttsValidation: {
        message: 'Sie haben {count} Zeichen ausgewählt.\nBitte versuchen Sie, bis zu {max} Zeichen auszuwählen.',
    },
    aiValidation: {
        message: 'Sie haben {count} Zeichen ausgewählt.\nBitte wählen Sie zwischen {min} und {max} Zeichen.',
    },
    alreadyPurchased: 'Already purchased?',
    logIn: 'Log in',
    addToAList: 'Zur Liste hinzufügen',
    lists: 'Listen',
    nextSection: 'Nächster Abschnitt',
    prevSection: 'Vorheriger Abschnitt',
    new: 'Neu',
    skipLinks: {
        navLabel: 'Schnellzugriffslinks',
        showControls: 'Steuerungen anzeigen',
    },
    accessibility: {
        textSelected: '{count} Zeichen ausgewählt. Auswahlwerkzeuge verfügbar.',
        pageChanged: 'Seite {current} von {total}',
    },
};
